import { render, staticRenderFns } from "./AddToolDetailItem.vue?vue&type=template&id=54fdd58a"
import script from "./AddToolDetailItem.js?vue&type=script&lang=js&external"
export * from "./AddToolDetailItem.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports